<script setup lang="ts">
import { computed } from 'vue';
import type { TLlmTechnicalDetails } from '@/_core/entities/vulnerability/models/types';

const props = defineProps<{
  technicalDetails: TLlmTechnicalDetails | null;
}>();

const FIELD_LABELS: Record<keyof TLlmTechnicalDetails, string> = {
  summary: 'Summary',
  attackVector: 'Attack Vector',
  attackLocality: 'Attack Locality',
  privilegesRequired: 'Privileges Required',
  userInteraction: 'User Interaction',
  scope: 'Scope',
  confidentialityImpact: 'Confidentiality Impact',
  integrityImpact: 'Integrity Impact',
  availabilityImpact: 'Availability Impact',
};

const FIELD_ORDER = Object.keys(FIELD_LABELS) as (keyof TLlmTechnicalDetails)[];

const fields = computed(() => {
  if (!props.technicalDetails) return [];
  const details = props.technicalDetails;
  return FIELD_ORDER.filter((key) => details[key] !== null).map((key) => ({
    key,
    label: FIELD_LABELS[key],
    value: details[key] as string,
  }));
});
</script>

<template>
  <div class="tw:flex tw:flex-col tw:gap-4 tw:typography-small tw:text-secondary">
    <div v-for="field in fields" :key="field.key">
      <div class="tw:typography-h3 tw:text-main">{{ field.label }}</div>
      <div class="tw:mt-2">{{ field.value }}</div>
    </div>
  </div>
</template>
